import * as React from "react";
import { Box } from "src/components/Box";
import { Text } from "src/components/Text";
import styled from "styled-components";

type Props = {
  children: string;
  noBorder?: boolean;
  qualifier?: React.ReactNode;
  action?: React.ReactNode;
};

const QualifierWrapperEl = styled(Box)`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const SeparatorEl = styled.span`
  background-color: rgb(230, 233, 239);
  display: block;
  height: 4px;
  width: 100%;
`;

export const PageTitle = ({
  children,
  qualifier,
  action,
  noBorder = false,
}: Props) => (
  <Box marginBottomL>
    <Box flex justifyBetween alignItemsCenter marginBottomM>
      <Box flex>
        {qualifier && (
          <QualifierWrapperEl marginRightL>{qualifier}</QualifierWrapperEl>
        )}
        <Text fontSize="xlarge" fontWeight="demi">
          {children}
        </Text>
      </Box>
      {action}
    </Box>
    {!noBorder && <SeparatorEl />}
  </Box>
);
